import { gql, useMutation, useQuery } from '@apollo/client';
import { SwitchField } from '@ovComponents/3-pattern/switchField/switchField';
import { useEffect, useState } from 'react';

const FETCH_ORGANIZATION = (field: string) => gql`
  query fetchOrganization($organizationId: String!) {
    fetchOrganization(organizationId: $organizationId) {
      organization {
        id
        ${field}
      }
    }
  }
`;

const UPDATE_ORGANIZATION = (field: string) => gql`
  mutation updateOrganization($input: UpdateOrganizationInput!) {
    updateOrganization(input: $input) {
      organization {
        id
        ${field}
      }
    }
  }
`;

export const UpdateOrganizationSwitch = ({
  organizationId,
  field,
  label,
  refetchQueries,
  onToggle,
  beforeToggle,
}: {
  organizationId?: string;
  field: string;
  label: string;
  refetchQueries?: any[];
  onToggle?: (isEnabled: boolean) => void;
  beforeToggle?: (
    nextEnabled: boolean,
    currentEnabled: boolean,
  ) => boolean | Promise<boolean>;
}) => {
  const [checked, setChecked] = useState(false);
  const [switchResetKey, setSwitchResetKey] = useState(0);

  const { data } = useQuery(FETCH_ORGANIZATION(field), {
    variables: { organizationId },
    skip: !organizationId,
  });

  const [updateOrganization] = useMutation(UPDATE_ORGANIZATION(field), {
    refetchQueries,
  });

  useEffect(() => {
    setChecked(data?.fetchOrganization?.organization[field]);
  }, [data, field]);

  const handleToggle = async () => {
    const nextChecked = !checked;
    const shouldProceed = await beforeToggle?.(nextChecked, checked);
    if (shouldProceed === false) {
      // Reset the visual toggle state when action is blocked by guard.
      setSwitchResetKey((prev) => prev + 1);
      return;
    }

    updateOrganization({
      variables: {
        input: {
          organizationId,
          [field]: nextChecked,
        },
      },
      onCompleted: () => {
        setChecked(nextChecked);
        onToggle?.(nextChecked);
      },
    });
  };

  return (
    <SwitchField
      key={switchResetKey}
      checked={checked}
      onChange={handleToggle}
      label={label}
    />
  );
};
